<ng-template #content_payment_gateway_config let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.qr_payment">
        <div class="side_popup_header">
            <span>{{localService.languageContent.qr_payment.header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;"
        [ngStyle]="{'max-height' : (localService.sideBarBodyHeight - 50) + 'px'}" *ngIf="configData">
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_payment.title" [IsMandatory]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="configData.v5"
                        title="{{localService.languageContent.qr_payment.title}}" id="{{elementIds.title}}"
                        placeholder="{{localService.languageContent.qr_payment.title}}" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_payment.merch_id" [IsMandatory]="true"
                        [IsNeedNewLine]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="text" [(ngModel)]="configData.v2"
                        title="{{localService.languageContent.qr_payment.merch_id}}" id="{{elementIds.merch_id}}"
                        placeholder="{{localService.languageContent.qr_payment.merch_id}}" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_payment.salt_idx" [IsMandatory]="true"
                        [IsNeedNewLine]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="number" class="en"
                        style="text-align: left;width: calc(100% - 50px);" [(ngModel)]="configData.v7"
                        title="{{localService.languageContent.qr_payment.salt_idx}}"
                        [ngClass]="configData.v7 ? 'en' : ''"
                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                        placeholder="{{localService.languageContent.qr_payment.salt_idx}}"
                        id="{{elementIds.salt_idx}}" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_payment.salt_key" [IsMandatory]="true"
                        [IsNeedNewLine]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="text" [(ngModel)]="configData.v4"
                        title="{{localService.languageContent.qr_payment.salt_key}}" id="{{elementIds.salt_key}}"
                        placeholder="{{localService.languageContent.qr_payment.salt_key}}" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_payment.contact" [IsMandatory]="true"
                        [IsNeedNewLine]="true" />
                    <i class="material-icons menu_icon verify_icon"
                        [ngClass]="{'verify_success': isMobileOtpVerified}">done</i>
                </div>
                <div>
                    <span class="en">+{{contactPrefix}}</span>
                    <input autocomplete="off" type="number" class="en"
                        style="text-align: left;width: calc(100% - 50px);" [(ngModel)]="configData.v6"
                        title="{{localService.languageContent.qr_payment.contact}}"
                        [ngClass]="configData.v6 ? 'en' : ''"
                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                        (input)="isMobileOtpVerified = false"
                        placeholder="{{localService.languageContent.qr_payment.contact}}" id="{{elementIds.contact}}" />
                </div>
                <div>
                    <app-otp-container *ngIf="isShowMobileOtpPopup" [IsOtpPopup]="false" [PhNumOrEmail]="configData.v6"
                        (onVerified)="onVerifiedOtp($event,otpType.MobileVerification)"
                        [otpType]="otpType.RelationshipVerification" (onCancelled)="isShowMobileOtpPopup = false" />
                </div>
            </div>
        </div>
    </div>
    <div class="side_popup_footer" *ngIf="configData">
        <div class="row">
            <div class="col-12" style="text-align: right;">
                <button type="button" class="btn btn-primary" *ngIf="!isMobileOtpVerified"
                    [id]="elementIds.verify_contact" [disabled]="configData.v6.toString().length != contactLength"
                    (click)="onAction(2)">{{localService.languageContent.qr_payment.verify_contact}}</button>
                <button *ngIf="isMobileOtpVerified" id="{{elementIds.btn_save}}" type="button" class="btn btn-primary"
                    (click)="onAction(1)">
                    {{id ? localService.languageContent.common.update :
                    localService.languageContent.common.create}}
                </button>
            </div>
        </div>
    </div>
</ng-template>